module.exports = __webpack_public_path__ + "static/carousel-1-sm-4c5132fa6fe14287b0bd16ac93bde15b.png";